<template>
  <v-card flat color="transparent" data-aos="fade">
    <v-container>
      <v-layout row wrap justify-space-around>
        <v-flex class="text-center" xs12 sm5 mb-5>
          <v-img :src="image" class="elevation-2" :height="imgHeight"></v-img>
          <v-btn
            class="book-now"
            color="primary"
            href="https://www.eventbrite.co.uk/e/gifts-from-the-wholesome-kitchen-tickets-127788545981"
            target="_blank">
              Book Now
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <h1>Gifts from the Wholesome Kitchen</h1>
          <v-layout class="pricing-details" row justify-space-between>
            <v-flex class="text-center">
              2 HOUR FESTIVE WORKSHOP
            </v-flex>
          </v-layout>
          <p>
            Create your own delicious edible gifts to give to family and friends this Christmas!
          </p>
          <p>
            Come and join us at the beautiful Nourish Café to make nourishing gourmet goodies like Cardamom &amp;
            Coconut Cookies, Christmas Sauerkraut, Orange Fermented Honey...
          <p/>
          <p>
            A festive drink, nibbles and music will set the scene while you make your very own edible gifts and you
            will take home your personalised bag full of goodies.
          </p>
          <p>
            Spaces for the workshop are very limited to follow guidelines and ensure you get a lot of attention.
          </p>
          <p>
            I proudly support our local businesses and source ingredients locally and grown organically. The raw
            honey comes from a sustainable beekeeper in St Albans. I use natural produce free of refined sugars,
            refined flours, eggs and dairy. All ingredients and material are provided and will be cleaned
            thoroughly before use.
          </p>
          <p>
            I can't wait to see you there!
          </p>
          <p>
            <b>Dates and Times</b> <br/>
            Saturday 12th December 4pm - 6pm <br/>
          </p>
          <p>
            <b>Location</b> <br/>
            <a href="https://www.nourishcafe.co.uk/" target="_blank">Nourish Wholefood Café</a> <br/>
            <span class="address">
              Hitchin Road <br/>
              Letchworth Garden City <br/>
              Hertfordshire <br/>
              SG6 3NA
            </span>
          </p>
          <p>
            <b>Investment</b> <br/>
            £50<br/>
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import MetaInfoBuilder from '@/utils/social'

export default {
  computed: {
    imgHeight() {
      return this.$vuetify.breakpoint.xsOnly ? '300px' : '600px'
    }
  },
  data: () => ({
    image: require('@/assets/images/festive.jpg?vuetify-preload'),
    showMenu: false,
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description('Create your own delicious edible gifts to give to family and friends this Christmas!')
      .image(`${window.location.origin}${this.image.src}`)
      .title('Gifts from the Wholesome Kitchen')
      .build()
  },
}
</script>

<style scoped>
h1 {
  color: rgb(175 150 117);
  font-family: 'Karla', sans-serif;
  font-weight: bold;
  text-transform: none;
  font-size: 40px;
  text-align: center;
}

.address {
  font-size: 16px;
}

.book-now {
  margin-top: 20px;
}

.flyer {
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}

.terms p {
  font-size: 15px;
  font-style: italic;
}

.pricing-details {
  color: #697b5e;
  border-bottom: 1px solid #697b5e;
  margin-bottom: 23px;
  padding-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.v-image {
  margin-top: 14px;
}

strong {
  color: rgb(0,94,54);
  font-size: 25px;
}
</style>
